import { ITableField } from '../../../../../../../shared/Table'
import { IFaqArticleSearchTag } from '../../../../faq.types'
import timeUtils from '../../../../../../../utils/time.utils'

const articleSearchTagsTableFields: Array<ITableField<IFaqArticleSearchTag, keyof IFaqArticleSearchTag>> = [
  {
    key: 'name',
    header: 'Название',
    getter: (field) => field.name,
    sortGetter: (field) => field.name,
    width: '150px',
  },
  {
    key: 'articles',
    header: 'Прикрепленные статьи',
    getter: (field) => String(field.articles?.length),
    sortGetter: (field) => field.articles?.length,
    width: '150px',
  },
  {
    key: 'createdAt',
    header: 'Дата создания',
    getter: (field) => timeUtils.formatDateTimeStringToPreview(field.createdAt),
    sortGetter: (field) => field.createdAt,
    width: '70px',
  },
  {
    key: 'updatedAt',
    header: 'Дата обновления',
    getter: (field) => timeUtils.formatDateTimeStringToPreview(field.updatedAt),
    sortGetter: (field) => field.updatedAt,
    width: '70px',
  },
]
export default articleSearchTagsTableFields
